import { useEffect, useRef } from 'react';

type OwnedStyles = { position: string; top: string; paddingTop: string };
const originalStyles = new WeakMap<HTMLElement, OwnedStyles>();
let instanceCounter = 0;

export const useBGBannerPadding = (
  headerHeight: number,
  isHomePage: boolean,
  shouldBannerBeFixed = false,
  isHeaderFixed = false,
  selectors: string[] = ['.lotriver-bg-left', '.lotriver-bg-right']
) => {
  const idRef = useRef('');
  if (!idRef.current) {
    instanceCounter += 1;
    idRef.current = `bg${instanceCounter}`;
  }

  useEffect(() => {
    const id = idRef.current;
    let frameId: number;

    const updatePadding = () => {
      const shouldPinBanner = shouldBannerBeFixed && isHeaderFixed;

      selectors.forEach(selector => {
        const el = document.querySelector(selector);
        if (!(el instanceof HTMLElement)) return;

        if (!originalStyles.has(el)) {
          if (el.style.position && !el.dataset.bgForced) {
            originalStyles.set(el, {
              position: el.style.position,
              top: el.style.top,
              paddingTop: el.style.paddingTop
            });
          } else {
            return;
          }
        }

        const isFixed = getComputedStyle(el).position === 'fixed';
        const owner = el.dataset.bgForced;
        const iOwn = owner === id;

        if (shouldPinBanner || (iOwn && isHeaderFixed)) {
          if (!owner || iOwn) {
            el.dataset.bgForced = id;
            if (!isFixed) {
              el.style.position = 'fixed';
              el.style.top = '0';
            }
            el.style.paddingTop = `${headerHeight}px`;
          }
          return;
        }

        if (iOwn) {
          const original = originalStyles.get(el);
          if (original) {
            el.style.position = original.position;
            el.style.top = original.top;
            el.style.paddingTop = original.paddingTop;
          }
          delete el.dataset.bgForced;
          return;
        }

        if (!owner) {
          el.style.paddingTop =
            !isHomePage && isFixed ? `${headerHeight}px` : '';
        }
      });

      frameId = requestAnimationFrame(updatePadding);
    };

    updatePadding();

    return () => cancelAnimationFrame(frameId);
  }, [
    isHomePage,
    headerHeight,
    selectors.join(','),
    shouldBannerBeFixed,
    isHeaderFixed
  ]);

  useEffect(
    () => () => {
      const id = idRef.current;
      selectors.forEach(selector => {
        const el = document.querySelector(selector);
        if (!(el instanceof HTMLElement) || el.dataset.bgForced !== id) return;

        const original = originalStyles.get(el);
        if (original) {
          el.style.position = original.position;
          el.style.top = original.top;
          el.style.paddingTop = original.paddingTop;
        }
        delete el.dataset.bgForced;
      });
    },
    []
  );
};
